/**
 * Klaviyo "Back in Stock" notify-me form.
 *
 * The Terns theme is heavily customized, so Klaviyo's onsite auto-placement of the
 * "Notify me" button can't find an anchor in the out-of-stock state. Instead we render
 * our own controls (see snippets/variant-options.liquid) and subscribe via Klaviyo's
 * browser-safe client Back-in-Stock endpoint. The existing "Back in Stock - Terns" flow
 * still fires because it triggers on the subscription event, regardless of source.
 *
 * Note: these controls live INSIDE the theme's <form id="product-form" action="/cart/add">,
 * so we deliberately avoid a nested <form> and avoid name= attributes (which would be
 * serialized into the cart request). The wrapper is a <div> and fields use data-* hooks.
 */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var REVISION = '2024-10-15';

  function setMessage(wrap, text, isError) {
    var msg = wrap.querySelector('.bis-message');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    msg.classList.toggle('bis-message--error', !!isError);
  }

  function subscribe(company, email, variantId) {
    return fetch(ENDPOINT + '?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
            }
          }
        }
      })
    });
  }

  function submit(wrap) {
    var company = wrap.getAttribute('data-company');
    var emailField = wrap.querySelector('[data-bis-email]');
    var variantField = wrap.querySelector('[data-bis-variant]');
    var button = wrap.querySelector('.bis-subscribe');
    var email = emailField ? emailField.value.trim() : '';
    var variantId = variantField ? variantField.value : '';

    // Validate with the native Constraint Validation API (the input has
    // type="email" + required), but render our OWN styled message instead of the
    // browser's native bubble. The native bubble can't be styled (Chrome dropped
    // the ::-webkit-validation-bubble pseudo-elements), so we use checkValidity()
    // to test and show a themed message that matches the buy area.
    if (emailField && typeof emailField.checkValidity === 'function') {
      if (!emailField.checkValidity()) {
        setMessage(
          wrap,
          emailField.validity.valueMissing
            ? 'Please enter your email address'
            : 'Please enter a valid email address',
          true
        );
        emailField.focus();
        return;
      }
    } else if (!email || email.indexOf('@') === -1) {
      setMessage(wrap, 'Please enter a valid email address', true);
      return;
    }

    if (!variantId || !company) {
      setMessage(wrap, 'Something went wrong. Please try again.', true);
      return;
    }

    if (button) {
      button.disabled = true;
      button.classList.add('loading');
    }

    function fail(message) {
      setMessage(wrap, message, true);
      if (button) { button.disabled = false; button.classList.remove('loading'); }
    }

    subscribe(company, email, variantId)
      .then(function (res) {
        if (res.status === 202 || res.ok) {
          if (emailField) { emailField.value = ''; emailField.style.display = 'none'; }
          if (variantField && variantField.tagName === 'SELECT') variantField.style.display = 'none';
          if (button) button.style.display = 'none';
          setMessage(wrap, "Thanks! We'll email you when it's back in stock.", false);
          return;
        }
        // Klaviyo returns a JSON:API error body. When an error concerns the email
        // (detail or source.pointer mentions it), show the email validation note;
        // otherwise fall back to a generic message.
        return res.json().then(function (d) { return d; }, function () { return null; })
          .then(function (data) {
            var emailError = data && Array.isArray(data.errors) && data.errors.some(function (e) {
              return /email/i.test((e.source && e.source.pointer) || '') || /email/i.test(e.detail || '');
            });
            fail(emailError ? 'Please enter a valid email address' : 'Something went wrong. Please try again');
          });
      })
      .catch(function () {
        fail('Something went wrong. Please try again');
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.bis-subscribe');
    if (!button) return;
    var wrap = button.closest('.bis-klaviyo-form');
    if (wrap) submit(wrap);
  });

  // Pressing Enter in the email field would otherwise submit the surrounding cart form.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var field = e.target.closest && e.target.closest('.bis-klaviyo-form [data-bis-email]');
    if (!field) return;
    e.preventDefault();
    var wrap = field.closest('.bis-klaviyo-form');
    if (wrap) submit(wrap);
  });
})();
